'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartItemWarning } from './cart-item-warning.component';

const DUPLICATED_PROCEDURE_LABEL = 'Procedimentos duplicados';

export function CartItemDuplicateWarning() {
  return (
    <CartItemWarning dataTestId={DataTestIdEnum.CART_ITEM_DUPLICATE_WARNING}>
      {DUPLICATED_PROCEDURE_LABEL}
    </CartItemWarning>
  );
}
